module.exports = __webpack_public_path__ + "static/media/app-banner.141158bc.png";